<template>
  <div class="trailer-loader-container">
    <vue-content-loading
      :width="300"
      :height="30">
      <rect
        x="0"
        y="0"
        rx="4"
        ry="4"
        width="300"
        height="30" />
    </vue-content-loading>
    <el-row
      type="flex"
      class="trailer-loader">
      <div
        v-for="(n, index) in totalItems"
        :key="index">
        <vue-content-loading
          :width="size"
          :height="size">
          <circle
            :cx="circleSize"
            :cy="circleSize"
            :r="circleSize" />
          <rect
            :x="rectangle.x"
            :y="rectangle.y"
            :width="rectangle.width"
            :height="rectangle.height"
            rx="4"
            ry="4" />
        </vue-content-loading>
      </div>
    </el-row>
  </div>
</template>
<script>
import VueContentLoading from 'vue-content-loading';

export default {
  name: 'TrailerLoaderComponent',
  components: {
    VueContentLoading,
  },
  data() {
    return {
      totalItems: 8,
      circleSize: 120,
      rectangle: {
        x: 0,
        y: 260,
        width: 250,
        height: 50,
      },
    };
  },
  computed: {
    size() {
      let size = 300;
      if (window.outerWidth <= 567) {
        size = 120;

        this.updateItems();
      }
      return size;
    },
  },
  methods: {
    updateItems() {
      this.totalItems = 3;
      this.circleSize = 50;
      this.rectangle.y = 110;
      this.rectangle.width = 110;
      this.rectangle.height = 20;
    },
  },
};
</script>

<style lang="scss">
.trailer-loader-container{
  overflow: hidden;
  svg {
    height: 30px;
    width: 300px;
  }
  .trailer-loader {
    margin-top: 2rem;
    svg {
      height: 163px;
      width: 163px;
    }
  }
}
@media (max-width: 576px) {
  .trailer-loader-container{
    overflow: hidden;
    svg {
      height: 20px;
      width: 100px;
    }
    .trailer-loader {
      margin-top: 1rem;
      svg {
        height: 120px;
        width: 120px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// app/src/components/loaders/TrailerLoader.vue